export {default as zoom} from "./src/zoom";
export {default as zoomTransform, identity as zoomIdentity} from "./src/transform";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-zoom/index.js
// module id = 480
// module chunks = 0 1 2 3 4